import React, { useState } from 'react';
import {
  Grid, Segment, Button, Form, Message, Divider,
} from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SemanticField from '../../app/common/form/SemanticField';

const roleOptions = [
  { key: 'superadmin', value: 'superadmin', text: 'Super Admin' },
  { key: 'ksi', value: 'ksi', text: 'KSI' },
  { key: 'knra', value: 'knra', text: 'KNRA' },
  { key: 'user', value: 'user', text: 'User (read-only)' },
];

export const SignUp = () => {
  const [authError, setAuthError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const validationSchema = Yup.object({
    nom: Yup.string().required('Last name is required'),
    prenom: Yup.string().required('First name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .required('Password is required'),
    type_utilisateur: Yup.string().required('Role is required'),
  });

  return (
    <Grid>
      <Grid.Row centered>
        <Grid.Column width={8}>
          <Segment.Group>
            <Segment attached='top'>
              <h5>Create a new user account</h5>
            </Segment>
            <Segment attached='bottom'>
              <Formik
                initialValues={{
                  nom: '', prenom: '', email: '', password: '',
                  telephone: '', fonctionpro: '', etablissement: '',
                  type_utilisateur: 'ksi',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  setAuthError('');
                  setSuccessMsg('');
                  fetch('/api/auth/register', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(values),
                  })
                    .then(async (res) => {
                      const data = await res.json();
                      if (!res.ok) throw new Error(data.message || 'Error creating user');
                      return data;
                    })
                    .then(() => {
                      resetForm();
                      setAuthError('');
                      setSuccessMsg(`Account created for ${values.email} with role ${values.type_utilisateur}.`);
                    })
                    .catch((error) => {
                      setAuthError(error.message);
                      setSubmitting(false);
                    });
                }}
              >
                {({ dirty, isValid, handleSubmit, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    {successMsg && (
                      <Message positive>
                        <Message.Header>Account created</Message.Header>
                        <p>{successMsg}</p>
                      </Message>
                    )}
                    {authError && (
                      <Message negative>
                        <Message.Header>Error</Message.Header>
                        <p>{authError}</p>
                      </Message>
                    )}

                    <Form.Group widths='equal'>
                      <SemanticField label='Last name *' name='nom' component={Form.Input} placeholder='Last name' />
                      <SemanticField label='First name *' name='prenom' component={Form.Input} placeholder='First name' />
                    </Form.Group>

                    <SemanticField label='Email *' name='email' component={Form.Input} placeholder='address@email.com' />
                    <SemanticField label='Password *' name='password' type='password' component={Form.Input} placeholder='Minimum 8 characters' />

                    <SemanticField
                      label='Role *'
                      name='type_utilisateur'
                      component={Form.Select}
                      options={roleOptions}
                    />

                    <Divider horizontal>Optional information</Divider>

                    <SemanticField label='Phone' name='telephone' component={Form.Input} placeholder='+670 ...' />
                    <Form.Group widths='equal'>
                      <SemanticField label='Job title' name='fonctionpro' component={Form.Input} placeholder='e.g. Lawyer...' />
                      <SemanticField label='Organisation' name='etablissement' component={Form.Input} placeholder='e.g. KSI, NGO...' />
                    </Form.Group>

                    <Divider />
                    <Button
                      primary
                      content='Create account'
                      type='submit'
                      disabled={isSubmitting || !isValid || !dirty}
                      loading={isSubmitting}
                    />
                  </Form>
                )}
              </Formik>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default SignUp;
